<template>
  <div>
    <el-dialog
      v-if="visible"
      visible
      show-close
      :title="'合祥采购单导入'"
      top="5vh"
      width="90%"
      :close-on-click-modal="false"
      :before-close="() => cancel()"
      v-el-dialog-drag
    >
      <div style="font-size: 14px; color: #606266" class="mb-2">
        <el-form size="mini" inline>
          <el-form-item
            :label="$l('form_label_orderCust') || '订单客户'"
            required
          >
            <dict-select
              v-model="custCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('form_placeholder_orderCust') || '请选择订单客户'"
              style="width: 260px"
              size="mini"
              filterable
              clearable
            >
              <template slot-scope="{ options }">
                <el-option
                  v-for="item in customerOptions(options)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </template>
            </dict-select>
          </el-form-item>
        </el-form>
        <span class="mr-2">Current File:</span>
        <span>{{ fileName || '' }}</span>
      </div>
      <Main ref="main" :file="file" :data="data" />
      <div slot="footer">
        <el-button size="small" @click="cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="readFile(file)">
          {{ $l('btn_reloadFile') || '重新解析' }}
        </el-button>
        <el-button type="warning" size="small" @click="orderImport()">
          {{ $l('btn_reloadChoose') || '重新选择文件' }}
        </el-button>
        <el-button type="success" size="small" @click="confirm()">
          {{ $l('btn_confirmImport') || '确认导入' }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('tips_question_import') || '是否导入该数据？' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('btn_noImport') || '不导入' }}
        </el-button>
        <el-button @click="confirm()" type="primary" size="small">
          {{ $l('btn_import') || '导入' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
import { VXETable } from 'vxe-table'
import EditLoading from '@/mixins/edit-loading'

const DEFAULT_ORDER_CUST = {
  value: '086c7994-bcbe-42a1-9fc7-aba5dd6e4534',
  label: '北京京东世纪信息技术有限公司',
}
export default {
  components: { Main },
  mixins: [EditLoading],
  data() {
    return {
      visible: false,
      file: null,
      data: [],
      backDialogVisible: false,
      custCode: DEFAULT_ORDER_CUST.value,
    }
  },
  computed: {
    fileName() {
      return this.file?.name
    },
  },
  methods: {
    customerOptions(options) {
      const list = options || []
      if (list.some((item) => item.value === DEFAULT_ORDER_CUST.value)) {
        return list
      }
      return [DEFAULT_ORDER_CUST, ...list]
    },
    async orderImport() {
      const file = await this.chooseFile()
      if (!file) return
      this.readFile(file)
    },
    async chooseFile() {
      const { file } = await VXETable.readFile({
        types: ['csv', 'CSV', 'xlsx', 'XLSX'],
      }).catch(() => ({}))
      return file
    },
    async readFile(file) {
      if (!file) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomHxFtyPurchaseFileParseApi(file)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.file = file
      this.data = res.body?.data || []
      this.visible = true
    },
    cancel() {
      if (!this.data?.length) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.visible = false
      this.backDialogVisible = false
      this.custCode = DEFAULT_ORDER_CUST.value
    },
    async confirm() {
      // 校验订单是否存在错误信息
      if (!this.data?.length) {
        this.$message.error(this.$l('tips_noOrder') || '无订单信息，无法导入')
        return
      }

      const isError = this.data.some((row) => !!row.errorMsg)
      if (isError) {
        this.$message.error(
          this.$l('tips_orderError') || '订单还存在错误信息，请检查'
        )
        return
      }
      if (!this.custCode) {
        this.$message.error(this.$l('form_placeholder_orderCust') || '请选择订单客户')
        return
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomHxFtyPurchaseImportSaveApi({ list: this.data, custCode: this.custCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        if (res.msg) this.$message.error(res.msg)
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_import_ok') || '导入成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
  },
}
</script>
